import React from "react";

import shape1 from "../../images/shape/heading-shape-1.png";
import shape2 from "../../images/shape/heading-shape-2.png";
import b from "../../images/team/b.webp";
import c from "../../images/team/c.webp";
import a from "../../images/team/a.webp";
import e from "../../images/team/e.webp";
import f from "../../images/team/f.webp";

import ea from "../../images/team/jay.webp";

let Jay = () => {
  return (
    <>
      <section className="about-area pb-50">
        <div className="section-header">
          <div className="section-header text-center">
            <img src={ea} className="w100" alt="" />
          </div>
        </div>
        <div className="container">
          <div className="tab-pane mt-50" id="maya">
            <div className="row">
              <div className="col-md-12">
                <div className="profile-details">
                  <h3>Creative One</h3>
                  <hr />
                  <p>
                    The opportunity to know & understand different business
                    models across multiple industries and on top of that adding
                    value for those who become our clients is what excites and
                    motivates Jay to come to office everyday.
                  </p>
                  <br />
                  <p>
                    With an interest to explore and pursue extra-curricular
                    activities, Jay was selected as one of the 60 candidates for
                    the YLAC’s Policy in Action program in Mumbai where he
                    worked on a live project “Challenges & Performance of Smart
                    Cities Mission” for a Member of Parliament. He was also one
                    of 300 delegates selected from all over the world for
                    “Harvard Project for Asian & International Relations (HPAIR)
                    Conference 2019.”
                  </p>
                  <br />
                  <p>
                    Apart from being a banker in life, Jay is passionate about
                    piano and a Big Manchester United supporter.
                  </p>
                  <br />
                  <p>
                    Jay is a qualified Chartered Accountant and has cleared
                    level II of CFA (U.S.A).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-area pt-40 pb-50 animate__animated animate__fadeInUp animate__delay-3s animate__slow	2s">
        <div className="container">
          <div className="section-header mb-100">
            <div className="section-header text-center mb-50">
              <h4 className="section-title mb-25">
                <span>
                  <img src={shape1} className="mr-10" alt="" />
                </span>
                Other Members
                <span>
                  <img src={shape2} className="ml-10" alt="" />
                </span>
              </h4>
            </div>
          </div>

          <div className="d-flex">
            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/abhishek">
                  <img src={b} alt=" profile " className="img-responsive" />
                  <h6 className="namePosition">
                    Abhishek Taparia <br />
                    <span>
                      <small>(Co-Founder & CEO)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/maya">
                  <img src={c} alt=" profile " className="img-responsive" />
                  <h6 className="namePosition">
                    Maya Taparia <br />
                    <span>
                      <small>(Co-Founder & COO)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/mahesh">
                  <img src={a} className="img-responsive" alt="profile" />
                  <h6 className="namePosition">
                    Mahesh T.D. <br />
                    <span>
                      <small>(AVP)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/ankit">
                  <img src={e} alt=" profile " className="img-responsive" />
                  <h6 className="namePosition">
                    Ankit Parihar <br />{" "}
                    <span>
                      <small>(Senior Associate)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

            <div className="lineV1"></div>
            <div className="cardTee1">
              <li className="nav-item">
                <a href="/ashish">
                  <img src={f} alt=" profile " className="img-responsive" />
                  <h6 className="namePosition">
                    Ashish Chacko <br />{" "}
                    <span>
                      <small>(Analyst)</small>
                    </span>
                  </h6>
                </a>
              </li>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Jay;
